angular.module('unica_media_directory.media_directory_services')

.factory('MediaDirectoryListService', function ($http, getBaseApiURL) {

	var mediaDirectoryListService = {};

	mediaDirectoryListService.listArchive = function (eventId, limit, offset)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/media-directory/list-archive/' + eventId,
			data: {
				limit: limit,
				offset: offset
			}
		}).then(function(result) {
			
			if ( result ) {
				return result.data.directories;
			}

		});

	};

	mediaDirectoryListService.list = function (eventId, limit, offset)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/media-directory/list/' + eventId,
			data: {
				limit: limit,
				offset: offset
			}
		}).then(function(result) {
			
			if ( result ) {
				return result.data.directories;
			}

		});

	};

	mediaDirectoryListService.get = function (mediaDirectoryId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/media-directory/detail/' + mediaDirectoryId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.directory;
			}

		});
	};

	mediaDirectoryListService.exportMedia = function ( eventId, isArchive )
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/export/media/' + eventId,
			data: { isArchive: isArchive }
		}).then(function(result) {

			if ( result ) {
				return result.data.url;
			}

		});
	};



	return mediaDirectoryListService;
});